import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const CreditCardIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.983 3.82028C14.3007 3.82028 14.5592 4.07872 14.5592 4.39645V12.6042C14.5592 12.9219 14.3007 13.1804 13.983 13.1804H2.65576C2.33751 13.1804 2.07907 12.9219 2.07907 12.6042V4.39645C2.07907 4.07872 2.33751 3.82028 2.65576 3.82028H13.983ZM15.5992 12.6042V4.39645C15.5992 3.50568 14.8743 2.78027 13.983 2.78027H2.65576C1.76447 2.78027 1.03906 3.50568 1.03906 4.39645V12.6042C1.03906 13.495 1.76447 14.2204 2.65576 14.2204H13.983C14.8743 14.2204 15.5992 13.495 15.5992 12.6042ZM12.9992 10.5803C12.9992 10.2928 12.7667 10.0603 12.4792 10.0603H4.15909C3.87205 10.0603 3.63908 10.2928 3.63908 10.5803C3.63908 10.8679 3.87205 11.1003 4.15909 11.1003H12.4792C12.7667 11.1003 12.9992 10.8679 12.9992 10.5803ZM5.7191 8.50032H4.15909C3.87205 8.50032 3.63908 8.26788 3.63908 7.98032V6.94031C3.63908 6.65274 3.87205 6.4203 4.15909 6.4203H5.7191C6.00666 6.4203 6.2391 6.65274 6.2391 6.94031V7.98032C6.2391 8.26788 6.00666 8.50032 5.7191 8.50032Z",
    fill: color
  }));
};
export default CreditCardIcon;